<template>
  <template v-if="order.delivery_method.id === 'pickup'">
    <p class="text-sm">Самовывоз из <strong>{{ order.stock.display_name || order.stock.name }}</strong></p>
  </template>
  <template v-else-if="order.delivery_method.id === 'on_premise'">
    <p class="text-sm">
      Заведение: <strong>{{ order.stock.display_name || order.stock.name }}</strong>
    </p>
    <p v-if="hasOnPremiseTable" class="text-sm">
      Номер стола: <strong>{{ order.meta_data.on_premise.table }}</strong>
    </p>
  </template>
  <template v-else-if="order.delivery_method.id === 'delivery'">
    <p class="text-sm" v-if="order.delivery_address === null">Доставка на неизвестный адрес</p>
    <template v-else>
      <p class="text-sm"><strong>{{ order.delivery_address.full }}</strong></p>
      <p class="text-sm" v-if="order.delivery_address.apartment">Кв./офис: <strong>{{ order.delivery_address.apartment }}</strong></p>
      <p class="text-sm" v-if="order.delivery_address.entrance">Подъезд: <strong>{{ order.delivery_address.entrance }}</strong></p>
      <p class="text-sm" v-if="order.delivery_address.floor">Этаж: <strong>{{ order.delivery_address.floor }}</strong></p>
      <p class="text-sm">Домофон: <strong>{{ order.delivery_address.has_intercom ? 'Есть/работает' : 'Нет/не работает' }}</strong></p>
      <p class="text-sm" v-if="order.stock && order.stock.id">
        Связанный склад: <strong>{{ order.stock.display_name || order.stock.name }}</strong>
      </p>
    </template>
  </template>
</template>

<script>
export default {
  props: {
    order: {
      required: true,
      type: Object,
    },
  },

  computed: {
    hasOnPremiseTable() {
      if (!this.order.meta_data) {
        return false
      } else if (!this.order.meta_data.on_premise) {
        return false
      }

      return !!this.order.meta_data.on_premise.table
    },
  },
}
</script>
